// Utility functions for generating context-specific CTA messages

export const generateCTAMessage = (context, data = {}) => {
  switch (context) {
    case 'service':
      return generateServiceCTA(data);
    case 'industry':
      return generateIndustryCTA(data);
    case 'page':
      return generatePageCTA(data);
    default:
      return getDefaultCTA();
  }
};

const generateServiceCTA = (service) => {
  if (!service || !service.title) {
    return getDefaultCTA();
  }
  let baseTitle = `Ready to Transform Your Business with ${service.title}?`;
  let subtitle = '';
  let badgeText = `Transform with ${service.title}`;
  let badgeIcon = service.icon;

  // Generate context-specific messaging based on service category
  switch(service.category) {
    case 'ai-ml':
      subtitle = `Let's discuss how our ${service.title.toLowerCase()} solutions can help you achieve your business goals and drive measurable results.`;
      break;
    case 'consulting':
      subtitle = `Let's discuss how our ${service.title.toLowerCase()} expertise can guide your AI transformation journey and maximize your ROI.`;
      badgeText = `Partner with ${service.title}`;
      badgeIcon = 'bi-handshake';
      break;
    case 'development':
      subtitle = `Let's discuss how our ${service.title.toLowerCase()} services can help you build robust, scalable solutions that grow with your business.`;
      badgeText = `Build with ${service.title}`;
      badgeIcon = 'bi-code-slash';
      break;
    case 'staffing':
      baseTitle = `Ready to Scale Your Team with Elite ${service.title}?`;
      subtitle = `Let's discuss how our pre-vetted ${service.title.toLowerCase()} professionals can help you build a world-class team and accelerate your projects.`;
      badgeText = `Hire with ${service.title}`;
      badgeIcon = 'bi-people-fill';
      break;
    case 'support':
      subtitle = `Let's discuss how our ${service.title.toLowerCase()} services can ensure your AI solutions run smoothly and deliver consistent value.`;
      badgeText = `Support with ${service.title}`;
      badgeIcon = 'bi-headset';
      break;
    default:
      subtitle = `Let's discuss how our ${service.title.toLowerCase()} solutions can help you achieve your business goals and drive measurable results.`;
  }

  return {
    title: baseTitle,
    subtitle,
    badgeText,
    badgeIcon,
    primaryButtonText: service.category === 'staffing' ? "Hire Talent Now" : "Start Your Project",
    secondaryButtonText: service.category === 'staffing' ? "Schedule Interview" : "Schedule a Call",
    primaryButtonIcon: service.category === 'staffing' ? "bi-people-fill" : "bi-rocket-takeoff",
    secondaryButtonIcon: "bi-calendar-check"
  };
};

const generateIndustryCTA = (industry) => {
  return {
    title: `Ready to Transform Your ${industry.title} Business?`,
    subtitle: `Let's discuss how our AI solutions can address your specific ${industry.title.toLowerCase()} challenges and drive measurable results.`,
    badgeText: `Transform ${industry.title}`,
    badgeIcon: "bi-building",
    primaryButtonText: "Start Your Project",
    secondaryButtonText: "Schedule a Call",
    primaryButtonIcon: "bi-rocket-takeoff",
    secondaryButtonIcon: "bi-calendar-check"
  };
};

const generatePageCTA = (pageData) => {
  switch (pageData.type) {
    case 'services':
      return {
        title: "Ready to Transform Your Business with AI?",
        subtitle: "Let's discuss how our comprehensive AI solutions can address your specific challenges and drive measurable results across all areas of your business.",
        badgeText: "Transform Your Business",
        badgeIcon: "bi-stars",
        primaryButtonText: "Start Your Project",
        secondaryButtonText: "Schedule a Call",
        primaryButtonIcon: "bi-rocket-takeoff",
        secondaryButtonIcon: "bi-calendar-check"
      };
    case 'company':
      return {
        title: "Ready to Partner with <span style=\"color: #0ea5e9; font-weight: 600;\">Vallen AI</span>?",
        subtitle: "Let's discuss how our experienced team can help your business overcome challenges and achieve new levels of success with cutting-edge AI solutions.",
        badgeText: "Partner with Us",
        badgeIcon: "bi-handshake",
        primaryButtonText: "Start Your Project",
        secondaryButtonText: "Schedule a Call",
        primaryButtonIcon: "bi-rocket-takeoff",
        secondaryButtonIcon: "bi-calendar-check"
      };
    case 'home':
      return {
        title: "Ready to Reimagine with Generative AI?",
        subtitle: "Let's discuss how our proven playbooks can transform your data into business value and drive innovation.",
        badgeText: "Transform Your Business",
        badgeIcon: "bi-stars",
        primaryButtonText: "Start Your Project",
        secondaryButtonText: "Schedule a Call",
        primaryButtonIcon: "bi-rocket-takeoff",
        secondaryButtonIcon: "bi-calendar-check"
      };
    default:
      return getDefaultCTA();
  }
};

const getDefaultCTA = () => {
  return {
    title: "Ready to Transform Your Business?",
    subtitle: "Let's discuss how our AI solutions can help you achieve your business goals and drive measurable results.",
    badgeText: "Transform Your Business",
    badgeIcon: "bi-stars",
    primaryButtonText: "Start Your Project",
    secondaryButtonText: "Schedule a Call",
    primaryButtonIcon: "bi-rocket-takeoff",
    secondaryButtonIcon: "bi-calendar-check"
  };
}; 